module.exports = __webpack_public_path__ + "img/share.0a874889.svg";